import { render, staticRenderFns } from "./BulkUserModal.vue?vue&type=template&id=36c1223c&scoped=true"
import script from "./BulkUserModal.vue?vue&type=script&lang=js"
export * from "./BulkUserModal.vue?vue&type=script&lang=js"
import style0 from "./BulkUserModal.vue?vue&type=style&index=0&id=36c1223c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1223c",
  null
  
)

export default component.exports